<template>
  <div class="page-select-store">
    <div class="top">
      <div class="department-name" v-if="department_name">
        {{ department_name }}
      </div>
      <div class="search-wrapper">
        <div class="search-input-box">
          <input
            placeholder="搜索门店名称"
            class="search-input"
            type="text"
            confirm-type="search"
            v-model="keyword"
            @confirm="search"
          />
          <img
            v-if="keyword"
            class="clear-icon"
            src="../../assets/store-list/close-icon.png"
            alt=""
            @click="clearKeyword"
          />
        </div>
        <div class="search-btn" @click="search">搜索</div>
      </div>
      <div class="region-filter" @click="showRegionPicker = true">
        <span class="filter-label">选择门店区域：</span>
        <span class="filter-value" :class="{ 'has-value': selectedRegionText }">
          {{ selectedRegionText || "全部地区" }}
        </span>
        <template v-if="!selectedRegionText">
          <img
            class="arrow-icon"
            src="../../assets/store-list/down-arrow-icon.png"
            alt=""
            @click="showRegionPicker = true"
          />
        </template>
        <template v-else>
          <img
            class="close-icon"
            src="../../assets/store-list/close-icon.png"
            alt=""
            @click.stop="clearRegion"
          />
        </template>
      </div>
    </div>
    <div class="store-list-box">
      <div class="title">门店列表</div>
      <div
        class="store-list"
        v-infinite-scroll="infinite"
        v-infinite-scroll-disabled="is_loading_list"
        v-infinite-scroll-distance="10"
        v-if="list.length"
      >
        <div
          class="store-item"
          v-for="(item, index) in list"
          :key="index"
          @click="goPage(item)"
        >
          <div class="store-name">{{ item.store_name }}</div>
          <div class="address" v-if="item.address">{{ item.address }}</div>
          <div class="store-code">{{ item.store_code }}</div>
          <img
            class="arrow"
            src="https://select-oil-oss.vchangyi.com/wxapp/v2.2.9/arrow_right.png"
          />
          <div class="tag">
            近90天查询{{ item.select_num }}次
            <img
              class="tag-icon"
              src="https://select-oil-oss.vchangyi.com/wxapp/v2.2.9/tag.png"
            />
          </div>
        </div>
      </div>
      <div class="empty-page" v-else>
        <img
          src="https://select-oil-oss.vchangyi.com/wxapp/search-empty-bg.png"
        />
        <div class="tip">暂无门店</div>
      </div>
    </div>

    <div class="dialog" v-if="show">
      <div class="box">
        <div class="title">温馨提示</div>
        <div class="msg">
          该门店近90天选油助手查询次数不足50次，暂无法生成备货推荐报告。请您先推动门店使用选油助手，谢谢！
        </div>
        <div class="btn" @click="show = false">我知道了</div>
      </div>
    </div>

    <!-- 省市区选择弹窗 -->
    <div
      class="region-picker-dialog"
      v-if="showRegionPicker"
      @click.self="showRegionPicker = false"
    >
      <div class="region-picker-box">
        <div class="picker-header">
          <span class="picker-title">选择地区</span>
          <span class="picker-close" @click="showRegionPicker = false">×</span>
        </div>
        <div class="picker-tabs">
          <div
            class="tab-item"
            :class="{ active: activeTab === 'province' }"
            @click="switchTab('province')"
          >
            {{ selectedProvince.area_name || "请选择" }}
          </div>
          <div
            class="tab-item"
            :class="{
              active: activeTab === 'city',
              disabled: !selectedProvince.area_code,
            }"
            @click="selectedProvince.area_code && switchTab('city')"
          >
            {{ selectedCity.area_name || "请选择" }}
          </div>
          <div
            class="tab-item"
            :class="{
              active: activeTab === 'area',
              disabled: !selectedCity.area_code,
            }"
            @click="selectedCity.area_code && switchTab('area')"
          >
            {{ selectedArea.area_name || "请选择" }}
          </div>
        </div>
        <div class="picker-content">
          <div class="region-list">
            <div
              v-for="item in currentRegionList"
              :key="item.area_code"
              class="region-item"
              :class="{ active: isSelected(item) }"
              @click="selectRegion(item)"
            >
              {{ item.area_name }}
            </div>
          </div>
        </div>
        <div class="picker-footer">
          <div class="btn-cancel" @click="showRegionPicker = false">取消</div>
          <div class="btn-confirm" @click="confirmRegion">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/apis/maintenance-api.js";
export default {
  name: "store-list",
  data() {
    return {
      page_init: false,
      meta: {
        size: 15,
        page: 1,
      },
      is_loading_list: false, // 列表是否在加载中
      has_more: true, //是否有更多数据
      keyword: "",
      list: [],
      show: false,
      department_name: "",
      // 省市区筛选相关
      showRegionPicker: false,
      activeTab: "province",
      provinceList: [],
      cityList: [],
      areaList: [],
      selectedProvince: {},
      selectedCity: {},
      selectedArea: {},
      confirmedProvince: {},
      confirmedCity: {},
      confirmedArea: {},
    };
  },

  created() {
    this.department_name = this.$route.query.department_name;
    const urlParams = new URLSearchParams(window.location.search);
    // 埋点：从小程序进入 && 还没埋点
    if (urlParams.get("source") && !sessionStorage.getItem("hasBuried")) {
      this.fetchList(1);
      // 标记已埋点
      sessionStorage.setItem("hasBuried", "true");
    } else {
      this.fetchList();
    }
    // 加载省份列表
    this.fetchRegionList("0", "province");
  },

  mounted() {
    document.title = "选择门店";
  },

  computed: {
    /**
     * 当前选中的地区文本
     * @returns {string} 格式：省 > 市 > 区
     */
    selectedRegionText() {
      const parts = [];
      if (this.confirmedProvince.area_name) {
        parts.push(this.confirmedProvince.area_name);
      }
      if (this.confirmedCity.area_name) {
        parts.push(this.confirmedCity.area_name);
      }
      if (this.confirmedArea.area_name) {
        parts.push(this.confirmedArea.area_name);
      }
      return parts.join("-");
    },
    /**
     * 当前展示的地区列表
     * @returns {Array} 根据 activeTab 返回对应列表
     */
    currentRegionList() {
      const map = {
        province: this.provinceList,
        city: this.cityList,
        area: this.areaList,
      };
      return map[this.activeTab] || [];
    },
  },

  methods: {
    // 获取列表数据
    async fetchList(is_event) {
      if (this.is_loading_list) return;
      try {
        this.$loading.show();
        this.is_loading_list = true;
        const { code, data, meta, message } = await Api.getStoreListApi({
          store_name: this.keyword,
          dealer_code: this.$route.query.dealer_code,
          customer_id: this.$route.query.customer_id,
          nick_name: this.$route.query.nick_name,
          mobile: this.$route.query.mobile,
          source: this.$route.query.source,
          sign: this.$route.query.sign,
          page: this.meta.page,
          size: this.meta.size,
          is_event: is_event,
          province_name: this.confirmedProvince.area_name || "",
          city_name: this.confirmedCity.area_name || "",
          area_name: this.confirmedArea.area_name || "",
        });
        this.$loading.hide();
        this.is_loading_list = false;
        if (code == 0) {
          this.list = [...this.list, ...data];
          this.has_more = this.list.length < meta.total;
          this.page_init = true;
        } else {
          this.$toast.show({ message: message, showTime: 2 });
        }
      } catch (err) {
        this.$loading.hide();
        this.is_loading_list = false;
        console.log(err.message);
      }
    },

    // 搜索
    search() {
      this.list = [];
      this.page_init = false;
      this.meta.page = 1;
      this.fetchList();
    },

    // 清除搜索关键词
    clearKeyword() {
      this.keyword = "";
      this.search();
    },

    // 上拉加载
    infinite() {
      console.log("上拉加载～");
      if (!this.has_more || this.is_loading_list) {
        return;
      }
      this.meta.page++;
      this.fetchList();
    },

    goPage(item) {
      // 埋点
      Api.zhendaoClickEventApi({
        store_id: item.id,
        dealer_code: this.$route.query.dealer_code,
        customer_id: this.$route.query.customer_id,
        nick_name: this.$route.query.nick_name,
        mobile: this.$route.query.mobile,
        source: this.$route.query.source,
      });
      if (item.select_num < 50) {
        this.show = true;
      } else {
        this.goZhendao(item.id, item.store_name);
      }
    },

    // 跳转珍岛备货助手
    async goZhendao(mId, mName) {
      try {
        const { code, data, message } = await Api.getZhendaoTokenApi();
        if (code == 0) {
          window.location.href = `https://aiapp.digitalshell.com.cn/app?token=${
            data.token
          }&mId=${mId}&mName=${encodeURIComponent(mName)}`;
        } else {
          this.$toast.show({ message: message, showTime: 2 });
        }
      } catch (err) {
        console.log(err.message);
      }
    },

    /**
     * 获取省市区列表
     * @param {string} parentCode - 父级地区编码
     * @param {string} level - 级别：province/city/area
     */
    async fetchRegionList(parentCode, level) {
      try {
        const { code, data } = await Api.getRegionListApi({
          parent_area_code: parentCode,
        });
        if (code === 0) {
          if (level === "province") {
            this.provinceList = data || [];
          } else if (level === "city") {
            this.cityList = data || [];
          } else if (level === "area") {
            this.areaList = data || [];
          }
        }
      } catch (err) {
        console.log("获取地区列表失败:", err.message);
      }
    },

    /**
     * 切换标签页
     * @param {string} tab - 标签名：province/city/area
     */
    switchTab(tab) {
      this.activeTab = tab;
    },

    /**
     * 判断是否已选中
     * @param {Object} item - 地区项
     * @returns {boolean}
     */
    isSelected(item) {
      if (this.activeTab === "province") {
        return this.selectedProvince.area_code === item.area_code;
      }
      if (this.activeTab === "city") {
        return this.selectedCity.area_code === item.area_code;
      }
      if (this.activeTab === "area") {
        return this.selectedArea.area_code === item.area_code;
      }
      return false;
    },

    /**
     * 选择地区
     * @param {Object} item - 地区项
     */
    selectRegion(item) {
      if (this.activeTab === "province") {
        this.selectedProvince = item;
        this.selectedCity = {};
        this.selectedArea = {};
        this.cityList = [];
        this.areaList = [];
        this.fetchRegionList(item.area_code, "city");
        this.activeTab = "city";
      } else if (this.activeTab === "city") {
        this.selectedCity = item;
        this.selectedArea = {};
        this.areaList = [];
        this.fetchRegionList(item.area_code, "area");
        this.activeTab = "area";
      } else if (this.activeTab === "area") {
        this.selectedArea = item;
      }
    },

    /**
     * 确认选择地区
     */
    confirmRegion() {
      if (!this.selectedProvince.area_code) {
        this.$toast.show({ message: "请选择省份", showTime: 2 });
        return;
      }
      this.confirmedProvince = { ...this.selectedProvince };
      this.confirmedCity = { ...this.selectedCity };
      this.confirmedArea = { ...this.selectedArea };
      this.showRegionPicker = false;
      this.search();
    },

    /**
     * 清空已选择的地区
     */
    clearRegion() {
      this.confirmedProvince = {};
      this.confirmedCity = {};
      this.confirmedArea = {};
      this.selectedProvince = {};
      this.selectedCity = {};
      this.selectedArea = {};
      this.activeTab = "province";
      this.search();
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.page-select-store {
  background: #fbfbfb;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .top {
    position: relative;
    padding: 28/100rem 30/100rem 82/100rem 30/100rem;
    background: #fbd42c;
    .department-name {
      height: 44/100rem;
      line-height: 44/100rem;
      font-size: 26/100rem;
      font-weight: bold;
      color: #404040;
      padding-left: 54/100rem;
      background: url("https://select-oil-oss.vchangyi.com/wxapp/v2.2.9/department-icon.png")
        no-repeat left center;
      background-size: 44/100rem 44/100rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 15/100rem;
    }
    .search-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 90/100rem;
      .search-input-box {
        flex: 1;
        position: relative;
        display: flex;
        align-items: center;
        .search-input {
          width: 100%;
          height: 72/100rem;
          border-radius: 42/100rem;
          padding: 0 70/100rem 0 64/100rem;
          background: #ffffff
            url("https://select-oil-oss.vchangyi.com/wxapp/v2.2.9/search-icon.png")
            no-repeat 20/100rem center;
          background-size: 38/100rem 40/100rem;
          font-size: 22/100rem;
          color: #000000;
        }
        .clear-icon {
          position: absolute;
          right: 20/100rem;
          width: 32/100rem;
          height: 32/100rem;
          padding: 6/100rem;
        }
      }
      .search-btn {
        font-size: 24/100rem;
        color: #666666;
        margin-left: 12/100rem;
        font-weight: bold;
      }
    }
  }
  .store-list-box {
    position: relative;
    background: #fbfbfb;
    border-radius: 40/100rem 40/100rem 0 0;
    margin-top: -58/100rem;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    padding-bottom: 30/100rem;
    .title {
      font-weight: 600;
      font-size: 22/100rem;
      color: #a6a6a6;
      padding: 25/100rem 30/100rem;
    }
    .store-list {
      flex: 1;
      overflow-y: auto;
      .store-item {
        background: #ffffff;
        box-shadow: 0 12/100rem 32/100rem 0 rgba(207, 207, 207, 0.2);
        border-radius: 24/100rem;
        padding: 30/100rem;
        position: relative;
        margin: 0 30/100rem 30/100rem;
        min-height: 170/100rem;
        .store-name {
          max-width: 350/100rem;
          font-weight: 600;
          font-size: 26/100rem;
          color: #404040;
        }
        .address,
        .store-code {
          max-width: 450/100rem;
          font-size: 22/100rem;
          color: #afafaf;
          word-break: break-all;
        }
        .address {
          margin-top: 20/100rem;
        }
        .store-code {
          margin-top: 10/100rem;
        }
        .arrow {
          width: 22/100rem;
          height: 22/100rem;
          position: absolute;
          right: 36/100rem;
          top: 108/100rem;
        }
        .tag {
          height: 48/100rem;
          line-height: 48/100rem;
          background: #fce9e9;
          border-radius: 24/100rem 10/100rem 0 24/100rem;
          font-weight: 500;
          font-size: 20/100rem;
          color: #dd1d21;
          padding: 0 10/100rem 0 12/100rem;
          position: absolute;
          right: -22/100rem;
          top: 26/100rem;
          .tag-icon {
            width: 22/100rem;
            height: 18/100rem;
            position: absolute;
            bottom: -18/100rem;
            right: 0;
          }
        }
      }
    }
    .empty-page {
      transform: translateY(20vh);
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #666666;
      line-height: 34/100rem;
      font-size: 24/100rem;
      img {
        width: 133/100rem;
        height: 133/100rem;
        margin-bottom: 34/100rem;
      }
    }
  }
  .dialog {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    .box {
      width: 500/100rem;
      background: #ffffff;
      border-radius: 20/100rem;
      padding: 40/100rem 30/100rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      .title {
        font-weight: 600;
        font-size: 24/100rem;
        color: #282828;
      }
      .msg {
        font-size: 22/100rem;
        color: #999999;
        line-height: 40/100rem;
        margin: 30/100rem 0;
      }
      .btn {
        width: 350/100rem;
        height: 65/100rem;
        background: #fbce07;
        border-radius: 52/100rem;
        font-weight: 600;
        font-size: 24/100rem;
        color: #404040;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  // 省市区选择弹窗样式
  .region-picker-dialog {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 100;
    .region-picker-box {
      width: 100%;
      height: 70vh;
      background: #ffffff;
      border-radius: 40/100rem 40/100rem 0 0;
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      .picker-header {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100/100rem;
        position: relative;
        border-bottom: 1/100rem solid #f0f0f0;
        .picker-title {
          font-weight: 600;
          font-size: 30/100rem;
          color: #282828;
        }
        .picker-close {
          position: absolute;
          right: 30/100rem;
          top: 50%;
          transform: translateY(-50%);
          font-size: 40/100rem;
          color: #999999;
          padding: 20/100rem;
        }
      }
      .picker-tabs {
        display: flex;
        padding: 0 30/100rem;
        border-bottom: 1/100rem solid #f0f0f0;
        .tab-item {
          padding: 30/100rem 20/100rem;
          font-size: 26/100rem;
          color: #666666;
          position: relative;
          &.active {
            color: #dd1d21;
            font-weight: 600;
            &::after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              width: 40/100rem;
              height: 4/100rem;
              background: #dd1d21;
              border-radius: 2/100rem;
            }
          }
          &.disabled {
            color: #cccccc;
          }
        }
      }
      .picker-content {
        flex: 1;
        overflow-y: auto;
        padding: 20/100rem 30/100rem;
        .region-list {
          .region-item {
            padding: 24/100rem 0;
            font-size: 26/100rem;
            color: #404040;
            border-bottom: 1/100rem solid #f5f5f5;
            &.active {
              color: #dd1d21;
              font-weight: 600;
            }
          }
        }
      }
      .picker-footer {
        display: flex;
        padding: 20/100rem 30/100rem 40/100rem;
        gap: 20/100rem;
        .btn-cancel,
        .btn-confirm {
          flex: 1;
          height: 80/100rem;
          border-radius: 40/100rem;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 28/100rem;
          font-weight: 600;
        }
        .btn-cancel {
          background: #f5f5f5;
          color: #666666;
        }
        .btn-confirm {
          background: #fbce07;
          color: #404040;
        }
      }
    }
  }

  // 区域筛选样式
  .region-filter {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 26/100rem;
    left: 0;
    padding: 30/100rem 30/100rem 56/100rem;
    width: 100%;
    border-radius: 40/100rem 40/100rem 0 0;
    background: rgba(255, 255, 255, 0.5);
    .filter-label {
      flex-shrink: 0;
      font-weight: 500;
      font-size: 28/100rem;
      color: #393939;
    }
    .filter-value {
      flex: 1;
      font-weight: 500;
      font-size: 28/100rem;
      color: #393939;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-right: 12/100rem;
      &.has-value {
        color: rgba(221, 29, 33, 1);
        font-weight: 600;
      }
    }
    .arrow-icon {
      width: 24/100rem;
      height: 24/100rem;
      flex-shrink: 0;
      transition: transform 0.3s ease;
    }
    .close-icon {
      width: 34/100rem;
      height: 34/100rem;
      flex-shrink: 0;
      transition: all 0.2s ease;
    }
  }
}
.arrow-icon {
  width: 22/100rem;
  height: 22/100rem;
  margin-left: 10/100rem;
}
.close-icon {
  width: 22/100rem;
  height: 22/100rem;
  margin-left: 10/100rem;
}
</style>
